import styled from 'styled-components'

const Loading = styled.div`
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(234, 240, 247, 0.72);
  backdrop-filter: blur(2px);
  overflow: hidden;
  transition: .35s ease;
  z-index: 9999999;
  display: ${props => props.show ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
`

Loading.Img = styled.img`
  width: 88px;
  filter: drop-shadow(0 4px 12px rgba(40, 104, 64, 0.2));
`

export default Loading
